module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }